import LayerVector from 'ol/layer/Vector';

import Mediator from 'gisw/Classes/Mediator';
// @ts-ignore
import auth from 'gisw/Helpers/auth';
import messageObserver from 'gisw/Widgets/MessageManager/MessageObserver';

export default {
  preProcess () {
    // see eCounty/Index.cshtml for variables defined by server.

    Mediator.map = null;
    Mediator.currentTab = null;
    Mediator.activeTool = null;
    Mediator.currentToolGroup = null;
    Mediator.createAndShowPanel = null;

    /* 'global' methods */
    Mediator.getCurrentLayer = () => Mediator.layermanager.getCurrentLayer();
    Mediator.isExceedMaxZoom = () => Mediator.baseMapManager.isExceedMaxZoom();
    Mediator._processLoginData = _processLoginData.bind(Mediator);
    Mediator.initChurnZero = _initChurnZero;

    Mediator.getCurrentTabName = _getCurrentTabName;
    Mediator.getLayersVisibleAtCurrentScale = _getLayersVisibleAtCurrentScale;

    Mediator.getCurrentTabID = _getCurrentTabID;
    Mediator.getCurrentTabLabel = _getCurrentTabLabel;
    Mediator.getQueryParameter = _GetQueryParameter;

    // For eCountyDemo
    Mediator.getDemoCountyName = _getDemoCountyName;
    Mediator.getCountyDisplayName = _getCountyDisplayName;
    // Check Subscription based on CountyName,
    // or Tab name/ID in the future (Assessor sub VS EM sub)
    Mediator.CheckSub = _CheckSub;

    Mediator.GetLayerIDByName = _GetLayerIDByName;
    Mediator.GetLayerIDListByName = _GetLayerIDListByName;

    Mediator.RegisterPreserveLayer = _RegisterPreserveLayer.bind(Mediator);
    Mediator.RegisterProtectedLayer = _RegisterProtectedLayer.bind(Mediator);
    Mediator.ClearGraphics = _ClearGraphics;
    Mediator.preserveLayers = {};
    Mediator.protectedLayers = {};

    Mediator.GetFrontEndOptionIDByName = GetFrontEndOptionIDByName;
  },

  postProcess () {
    Mediator.centerMenu.setInitialTab();

    /** @type {import('gisw/Widgets/GenericSearch/Search').default} */
    const searchBar = Mediator.rightMenu.searchBar;

    Mediator.createAndShowPanel = params =>
      searchBar.createAndShowPanel(params);
  }
};

function _GetQueryParameter (paramName) {
  const parameterName = paramName + '=';
  const search = window.location.search;
  const slashIndex = search.indexOf('/');
  const query =
    slashIndex > 0 ? search.substring(1, slashIndex) : search.substring(1);
  const params = query.split('&');

  for (let i = 0; i < params.length; i++) {
    if (params[i].substring(0, parameterName.length) === parameterName) {
      return decodeURI(params[i].replace(parameterName, ''));
    }
  }

  return null;
}

/**
 * Returns the layers unique ID in the map service given its name.
 * In the case of duplicates the first will be selected.
 * @param {any} layerObj
 * @param {string} layerName
 */
function _GetLayerIDByName (layerObj, layerName) {
  for (let i = 0; i < layerObj.layerInfos.length; i++) {
    if (layerObj.layerInfos[i].name.toLowerCase() === layerName.toLowerCase()) {
      return layerObj.layerInfos[i].id;
    }
  }

  return null;
}

/**
 * @param {*} layerObj
 * @param {string} layerName
 */
function _GetLayerIDListByName (layerObj, layerName) {
  const temp = [];

  for (let i = 0; i < layerObj.layerInfos.length; i++) {
    if (
      layerObj.layerInfos[i].name
        .toLowerCase()
        .indexOf(layerName.toLowerCase()) !== -1
    ) {
      temp.push(i);
    }
  }

  return temp;
}

// Sometimes we want these layers to stick around (it depends)
function _RegisterPreserveLayer (layerId) {
  this.preserveLayers[layerId] = true;
}

// We want these removed only when the clear button is clicked
function _RegisterProtectedLayer (layerId) {
  this.protectedLayers[layerId] = true;
}

function _ClearGraphics (preserve, protect) {
  const layers = Mediator.map.getLayers();
  const preserveLayers = Mediator.preserveLayers;
  const protectedLayers = Mediator.protectedLayers;

  layers.forEach(function (layer) {
    const isProtected = !protect && protectedLayers[layer.ol_uid];
    const isPreserved = preserve && preserveLayers[layer.ol_uid];

    if (layer instanceof LayerVector && !isProtected && !isPreserved) {
      layer.getSource().clear();
    }
  });
}

/**
 * @param {string} name
 */
function GetFrontEndOptionIDByName (name) {
  if (Mediator.serverData && Mediator.serverData.FrontEndOption) {
    for (let i = 0; i < Mediator.serverData.FrontEndOption.length; i++) {
      if (Mediator.serverData.FrontEndOption[i].Options === name) {
        return i;
      }
    }
  }

  return -1;
}

/**
 * @param {string} entityName
 */
async function _CheckSub (entityName) {
  if (entityName === '') {
    // not subscriber
    return;
  }

  const data = await fetch('subscription/IsSubscriptionEntity', {
    method: 'post',
    body: JSON.stringify({ entityName }),
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      Accept: 'application/json'
    }
  }).then(res => res.json());

  const status = data.Status.Code;

  if (status !== 'OK') {
    messageObserver.broadcast({ title: 'Error', message: data.Status.Message });
    return;
  }

  // Update the isSub in detailsPanel
  // We might move isSub varibale to mediator when time permis
  Mediator.resultsPanel.detailsPanel.isSub = _dumbLogic(
    data.Features[0].Results.length > 0
  );
}

/**
 * Dumn logic from Flex code
 * Eventually this would be replaced with new logic codes
 * that take subscription and login.
 * @param {boolean} sub
 */
function _dumbLogic(sub) {
    // specific change for deuel  
    const countyName = _getCountyDisplayName().toLowerCase();
    // console.log("countyName=" + countyName);
    if (countyName === "deuel county" && auth.loggedIn === true) {
        return true;
    } else if (countyName != "deuel county" && (auth.loggedIn && sub || sub === false)) {
        return true;
    } else if (sub && auth.loggedIn === false) {
        // 1. Has Sub but NOT logged in
        return false;
    } else {
        return false;
    }
}

// eCountyDemo tab LABEL example:
// 1. 'Assessor | York'
// 2. 'Tax Director | Dunn'
// Default return name is the entity name/label
function _getDemoCountyName () {
  const curTabLabel = Mediator.getCurrentTabLabel();

  if (_isDemoTab(curTabLabel)) {
    return _getEntityNameFromDemoTab(curTabLabel);
  }

  return Mediator.serverData.entityName;
}

// GIS-288 - added to allow retreiving the county display name from the tab label  - JC 2024-02-21
function _getCountyDisplayName() {
    const curTabLabel = Mediator.getCurrentTabLabel();

    if (_isDemoTab(curTabLabel)) {
        return _getEntityNameFromDemoTab(curTabLabel);
    }

    return Mediator.serverData.displayName;
}

function _isDemoTab (curTabLabel) {
  return curTabLabel.indexOf('|') >= 0;
}

function _getEntityNameFromDemoTab (curTabLabel) {
  const tabLabelParts = curTabLabel.split('|');

  if (tabLabelParts.length > 1) {
    // Last part: Get the County name
    return tabLabelParts[tabLabelParts.length - 1].trim();
  }

  return curTabLabel;
}

function _getCurrentTabLabel () {
  return Mediator.serverData.TabLabel[_getCurrentTabName()];
}

function _getCurrentTabName () {
  let curTabName =
    Mediator.currentTab ||
    Mediator.serverData.startUpTab ||
    Mediator.serverData.Tabs[0];

  if (!curTabName && auth.loggedIn && auth.loginInfo?.Tabs) {
    curTabName = auth.loginInfo.Tabs[0].TabName;
  }

  return curTabName;
}

function _getCurrentTabID () {
  const name = _getCurrentTabName();

  for (let i = 0; i < Mediator.serverData.Tabs.length; i++) {
    if (Mediator.serverData.Tabs[i].toLowerCase() === name.toLowerCase()) {
      return Mediator.serverData.TabIDs[name].toString();
    }
  }

  if (auth.loggedIn && auth.loginInfo?.Tabs) {
    for (let i = 0; i < auth.loginInfo.Tabs.length; i++) {
      if (auth.loginInfo.Tabs[i].TabName.toLowerCase() === name.toLowerCase()) {
        return auth.loginInfo.Tabs[i].ID.toString();
      }
    }
  }

  return null;
}

function _processLoginData (LoginInfo) {
  this.layerConfigs = LoginInfo.LayerConfigurations;
  this.currentUser = LoginInfo.UserName;
  this.userRoles = LoginInfo.UserRoles;
  this.serverData.startUpTab =
    LoginInfo.StartUpTab || this.serverData.startUpTab;
  this.serverData.Tabs = [];
  this.serverData.TabTools = {};
  this.serverData.TabLayers = {};
  this.serverData.TabSubLayers = {};
  this.serverData.TabFeatureLayers = {};

  if (this.layermanager) {
    this.layermanager.widgetItems = {};
  }

  this.userPermissions = LoginInfo.UserPermissions.reduce(function (
    results,
    permission
  ) {
    results[permission.Name] = permission;
    return results;
  },
  {});

  for (let i = 0; i < LoginInfo.Tabs.length; i++) {
    const curTabInfo = LoginInfo.Tabs[i];
    const curTabName = curTabInfo.TabName;

    this.serverData.Tabs[i] = curTabName;
    this.serverData.TabLabel[curTabName] = curTabInfo.TabLabel;
    this.serverData.TabIDs[curTabName] = curTabInfo.DatabaseID;
    this.serverData.TabQuickSearches[curTabName] = curTabInfo.QuickSearches;

    this.serverData.TabFeatureLayers[curTabName] = curTabInfo.FeatureLayers;
    this.serverData.TabTools[curTabName] = curTabInfo.Tools;

    if (this.layermanager) {
      this.layermanager.processLoginData(curTabInfo);
    } else {
      this.serverData.TabLayers[curTabInfo.TabName] = curTabInfo.MapService;

      if (curTabInfo.SubMapService) {
        this.serverData.TabSubLayers[curTabInfo.TabName] =
          curTabInfo.SubMapService;
      }
    }
  }
}

function _initChurnZero () {
  window.ChurnZero.push([
    'setAppKey',
    'WjQlKSnP4LfrVTETxgnAijGNhZtvk78iKQnqTBzNRR0'
  ]);

  $.ajax('/churnzero/getexternalids', {
    dataType: 'json',
    success (Ids) {
      window.ChurnZero.push([
        'setContact',
        Ids.AccountExternalId,
        Ids.ContactExternalId
      ]);
    }
  });
}

function _getLayersVisibleAtCurrentScale () {
  // RESRI coming back to this
  const currentLayer = Mediator.getCurrentLayer();
  const currentVisibleLayers = currentLayer.visibleLayers;
  const currentScale = -1;
  const returnResult = [];
  let annotationID = -2;

  // ignore Annotation Layer for buffer
  for (let i = 0; i < currentVisibleLayers.length; i++) {
    const layer =
      currentLayer &&
      currentLayer.layerInfos &&
      currentLayer.layerInfos[currentVisibleLayers[i]];
    const isAnnotation = layer && layer.name === 'Annotation';

    if (isAnnotation) {
      annotationID = i;
    }
  }

  for (let j = 0; j < currentVisibleLayers.length; j++) {
    const curLayerInfo = _getCurrentLayerByID(
      currentLayer.layerInfos,
      currentVisibleLayers[j]
    );
    const isNotAnnotation =
      curLayerInfo &&
      !curLayerInfo.subLayerIds &&
      curLayerInfo.parentLayerId !== annotationID;
    const isInScaleRange =
      curLayerInfo &&
      (curLayerInfo.minScale === 0 || currentScale < curLayerInfo.minScale);

    if (isNotAnnotation && isInScaleRange) {
      returnResult.push(currentVisibleLayers[j]);
    }
  }

  return returnResult;
}

function _getCurrentLayerByID (layerInfos, layerID) {
  for (let i = 0; i < layerInfos.length; i++) {
    if (layerInfos[i].id === layerID) {
      return layerInfos[i];
    }
  }

  return null;
}
